import { post, get, put, destroy } from '../../utils/fetch'

const albumKeys = [
  'id',
  'title',
  'coverartURL',
  'description',
  'tags',
  'genre',
  'sales',
  'price',
  'nameyourprice',
  'status',
]

const soundKeys = [
  'id',
  'transcodeId',
  'title',
  'coverartURL',
  'description',
  'tags',
  'lyrics',
  'genre',
  'sales',
  'price',
  'nameyourprice',
  'status',
  'license',
  'ccType',
  'sampling',
  'limit',
  'limitFrom',
  'limitTo',
]

const stripByKeys = (keys, data) => {
  const result = {}
  keys.forEach((key) => {
    if (
      data[key] !== undefined
      || data[key] !== null
    ) {
      result[key] = data[key]
    }
  })
  return result
}

export const getAlbum = async (id: string) => {
  const album = await get(`/albums/${id}`)
  return album
}

export const getMyAlbums = (page = 1, perPage = 20, token = null) => {
  const sound = get(`/albums/my?page=${page}&perPage=${perPage}`, { token })
  return sound
}

export const getAlbumLikes = async (id) => ({ id })

export const createAlbum = async (albumData, soundDatas, orders) => {
  const album = stripByKeys(albumKeys, albumData)
  const sounds = soundDatas.map((sound) => stripByKeys(soundKeys, sound))
  const result = await post('/albums/', { album, sounds, orders })
  return result
}

export const updateAlbum = (data) => {
  const sound = put(`/albums/${data.id}`, data)
  return sound
}

export const clapAlbum = (id: string, times: number) => {
  const result = post(`/clap/album/${id}`, { times })
  return result
}

export const deleteAlbum = (id: string) => {
  const result = destroy(`/albums/${id}`)
  return result
}
